import { useOrganizationContextDataQuery } from './OrganizationContextDataQuery.generated';
import { sendErrorEvent } from '@trello/error-reporting';

export const useOrgContextData = (orgId: string | null) => {
  const { data, error } = useOrganizationContextDataQuery(
    orgId ? { variables: { orgId } } : { skip: true },
  );

  if (error)
    sendErrorEvent(error, {
      tags: { ownershipArea: 'trello-smoothie' },
    });

  return data;
};
